export const RESERVED = 'RESERVED'
export const ACTIVE = 'ACTIVE'
export const BLOCKED = 'BLOCKED'
export const CLOSURE = 'CLOSURE'
export const FREEZE = 'FREEZE'
export const TRIAL = 'TRIAL'
export const CLOSED = 'CLOSED'

export const PROFILE_TYPES = {
  PRIVATE: 'PRIVATE',
  LEGAL: 'LEGAL',
  REMITTANCE: 'REMITTANCE'
}

export const PROFILE_STATUSES = {
  [RESERVED]: 'RESERVED',
  [ACTIVE]: 'ACTIVE',
  [BLOCKED]: 'BLOCKED',
  [CLOSURE]: 'CLOSURE',
  [FREEZE]: 'FREEZE',
  [TRIAL]: 'TRIAL',
  [CLOSED]: 'CLOSED'
}
